module.exports = __webpack_public_path__ + "img/xy_gs.4eb480f.png";